<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        中心仓危险事件明细
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.alarmStartRange">
            <el-date-picker
              v-model="slotForms.forms.alarmStartRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.eventType">
            <el-select
              v-model="slotForms.forms.eventType"
              clearable
              filterable
              placeholder="危险事件类型"
            >
              <el-option
                v-for="item in dangerousOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.cameraInfo">
            <el-input
              v-model="slotForms.forms.cameraInfo"
              placeholder="摄像头编号/名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.comparyIds">
            <el-select
              v-model="slotForms.forms.comparyIds"
              multiple
              collapse-tags
              clearable
              filterable
              placeholder="企业名称"
            >
              <el-option
                v-for="item in comparyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.storageIds">
            <e6Select
              :dataList="storageOptions"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              :disabledNoCheck="true"
              multiple
              ref="storageTreeSelect"
              :placeholder="'仓库名称'"
              @multipleSelect="handleSelStorage"
            ></e6Select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="时间"
          min-width="180"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          prop="gpsTimeStr"
        ></el-table-column>
        <el-table-column
          label="危险事件类型"
          min-width="180"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="eventTypeStr"
        ></el-table-column>
        <el-table-column
          label="图片"
          min-width="150"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="eventPhoto"
        >
          <template slot-scope="{ row }">
            <div v-if="row.eventPhoto == ''">
              无
            </div>
            <el-badge
              :value="row.eventPhoto.split(',').length"
              class="item"
              v-else-if="row.eventPhoto.split(',').length > 1"
            >
              <div @click="openImg(row)">
                <el-image
                  style="width: 25px; height: 30px;padding-top:5px"
                  :src="row.eventPhoto.split(',')[0]"
                ></el-image>
              </div>
            </el-badge>
            <div v-else @click="openImg(row)">
              <el-image
                style="width: 25px; height: 30px;padding-top:5px"
                :src="row.eventPhoto.split(',')[0]"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="摄像头名称"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="cameraName"
        >
        </el-table-column>
        <el-table-column
          label="摄像头编号"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="cameraCode"
        >
        </el-table-column>
        <el-table-column
          label="使用对象"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="storageName"
        >
        </el-table-column>
        <el-table-column
          label="所属企业"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="comparyName"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="120"
          fixed="right"
          :show-overflow-tooltip="true"
          header-align="center"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="goToVideoHistory(row)"
              >查看回放</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!--照片弹框-->
    <el-dialog
      class="dialog-css"
      title="查看照片"
      :visible.sync="dialogPhotoVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      center
      @close="handlePhotoClose"
    >
      <div>
        <el-form :inline="true" :model="photoObj" class="demo-form-inline">
          <el-form-item label="危险事件类型">
            <span>{{ photoObj.eventType }}</span>
          </el-form-item>
          <el-form-item label="时间">
            <span>{{ photoObj.time }}</span>
          </el-form-item>
        </el-form>
        <el-image
          style="width: 100%;height:400px"
          :src="photoUrl.split(',')[0]"
          :preview-src-list="[...photoUrl.split(',')]"
        >
        </el-image>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPhotoVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  FetchDangerousDetailList,
  exportDangerousDetail,
  FetchStorageList
} from "@/api/report/dangerous";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";
import { cloneDeep } from "lodash";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          alarmStartRange: [
            this.$route.query.startTime ||
              moment()
                .subtract(3, "d")
                .startOf("day")
                .format("YYYY-MM-DD HH:mm:ss"),
            this.$route.query.endTime ||
              moment()
                .endOf("day")
                .format("YYYY-MM-DD HH:mm:ss")
          ],
          storageIds: this.$route.query.storageId
            ? [Number(this.$route.query.storageId)]
            : [], // 仓库名称
          comparyIds: this.$route.query.comparyId
            ? [Number(this.$route.query.comparyId)]
            : [],
          cameraInfo: "", // 摄像头编号/名称
          eventType: Number(this.$route.query.type) || ""
        },
        extends: []
      },
      formsExtend: [],
      comparyOptions: [],
      storageOptions: [],
      dangerousOptions: [
        {
          label: "未戴口罩",
          value: 1
        },
        {
          label: "未穿防护服",
          value: 2
        }
      ],
      tableData: [],
      loading: "false",
      datePickerOptions: datePickerOptionsNotContainToday,
      //导出URL
      exportUrl: "/report/cameraRisk/exportRiskDetail?",
      // 照片弹框
      dialogPhotoVisible: false,
      photoObj: {},
      photoUrl: ""
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    // 查询列表数据
    this.FetchFindByPage(this.mergeObj());
    this.setSearchFormIsOpenAct();
    this.FetchComparyList();
    this.FetchStorageList();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天
    validataTime() {
      let start = moment(this.formExtend.forms.alarmStartRange[0]);
      let end = moment(this.formExtend.forms.alarmStartRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    // 获取企业名称下拉
    FetchComparyList() {
      FetchAllComparys()
        .then(res => {
          if (res.result && res.result && Array.isArray(res.result)) {
            this.comparyOptions = res.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取仓库下拉
    FetchStorageList() {
      FetchStorageList()
        .then(response => {
          if (response.code == 1 && response.result) {
            this.storageOptions = response.result;
            if (this.$route.query.storageId) {
              this.$nextTick(() => {
                this.$refs.storageTreeSelect.setSelectList([
                  Number(this.$route.query.storageId)
                ]);
              });
            }
          } else {
            this.$message({
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格数据
    FetchFindByPage(response) {
      if (!response.alarmStartRange) {
        this.$message.warning("开始时间与结束时间不能为空！");
        return;
      }
      this.tableData = [];
      if (this.validataTime()) {
        this.loading = true;
        let params = cloneDeep(response);
        params.startTime = params.alarmStartRange[0];
        params.endTime = params.alarmStartRange[1];
        Reflect.deleteProperty(params, "alarmStartRange");
        FetchDangerousDetailList(params)
          .then(response => {
            if (
              response.result &&
              response.result.data &&
              Array.isArray(response.result.data)
            ) {
              this.tableData = response.result.data;
              this.total = response.result.totalRecords;
            }
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 选择仓库
    handleSelStorage(val) {
      this.formExtend.forms.storageIds = [];
      val.forEach(v => {
        this.formExtend.forms.storageIds.push(Number(v.id));
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    //重置
    handleResetForm() {
      this.$refs["storageTreeSelect"].multipleRemoveAll();
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    //导出
    async handleExportClick() {
      if (this.validataTime()) {
        let params = cloneDeep(this.mergeObj());
        params.startTime = params.alarmStartRange[0];
        params.endTime = params.alarmStartRange[1];
        Reflect.deleteProperty(params, "alarmStartRange");
        exportDangerousDetail(params).then(res => {
          // 导出
          exportXlsx(res, `中心仓危险事件明细.xls`);
        });
      }
    },
    // 查看照片
    openImg(row) {
      this.photoObj = row;
      this.photoUrl = row.photo;
      this.dialogPhotoVisible = true;
    },
    handlePhotoClose() {
      this.photoObj = {};
      this.photoUrl = "";
      this.dialogPhotoVisible = false;
    },
    // 跳转视频回放页面
    goToVideoHistory(row) {
      this.$router.push({
        path: "/warehousePlaybackVideo",
        query: {
          cameraCode: `camera_${row.cameraId}`,
          dangerousTime: moment(
            moment(row.gpsTimeStr).valueOf() - 30 * 1000
          ).format("YYYY-MM-DD hh:mm:ss")
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
/deep/ .el-badge__content {
  height: 14px;
  line-height: 14px;
  padding: 0 4px;
}
/deep/ .el-badge__content.is-fixed {
  top: 7px;
}
/deep/ .dialog-css {
  .el-dialog {
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__body {
      padding: 20px;
      .el-form-item__label {
        color: #949494;
      }
    }
    .el-dialog__header {
      padding: 10px;
      background-color: #efefef;
      text-align: left;
      .el-dialog__headerbtn {
        top: 15px;
      }
    }
  }
}
/deep/ .el-tag {
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
